import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, ViewChild, ViewContainerRef } from "@angular/core";
import { AppService } from "@api";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { ReporteEvaluacionPendientePreguntaEnviadaDetalleComponent } from "./preguntaenviadadetalle/preguntaenviadadetalle.component";


@Component(
    {
        selector: 'reporteevaluacionpendientepreguntaenviada',
        templateUrl: './preguntaenviada.component.html',
        styleUrls: ['./preguntaenviada.component.scss']
    })

export class ReporteEvaluacionPendientePreguntaEnviadaComponent implements AfterViewInit{
    consulta!: boolean;
    dataTable!: Array<any>;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string;

    SelPeriodoevaluacion:any[];
    SelDepartamento:any[];
    SelPuesto:any[];

    @ViewChild("preguntasenviadasdetalle", {read: ViewContainerRef}) preguntasenviadasdetalle!: ViewContainerRef;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
        this.uriApi = "reporte/preguntaenviada/buscar";

        this.SelPeriodoevaluacion = [];
        this.SelDepartamento = [];
        this.SelPuesto = [];
        this.GenerarFiltros();

    }

    ngAfterViewInit() {
        this.LoadDatos().then((respuesta : any)=>{
            this.filtrosComponent.SetFiltros(this.filtrosDisplay, true);
       })
    }

    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Periodo evaluación',
                    DisplayValor: 'descripcion',
                    ValorName: 'periodoevaluacionid',
                    Opciones: this.SelPeriodoevaluacion,
                    Propiedad: "periodoevaluacionid",
                    Obligatorio: true,
                    Buscar: true,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Departamento',
                    DisplayValor: 'nombre',
                    ValorName: 'departamentoid',
                    Opciones: this.SelDepartamento,
                    Propiedad: "departamentoid",
                    Obligatorio: false,
                    Buscar: true,
                    Suscripcion: new EventEmitter()
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Puesto',
                    DisplayValor: 'nombre',
                    ValorName: 'puestoid',
                    Opciones: this.SelPuesto,
                    Propiedad: "puestoid",
                    Obligatorio: false,
                    Buscar: false
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    async LoadDatos(){
        return new Promise((resolve) =>{
            Promise.all([
            this.SetDepartamentoFiltro(),
            this.SetPeriodoevaluacion(),
          ]).then((responses : any) =>{
            return resolve(responses);
          });
        });
      }



    SetPeriodoevaluacion(){
        return new Promise ((resolve) =>{
            this.appService.Post("planeacion/periodoevaluacion/buscar",{}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success) {
                    this.SelPeriodoevaluacion = res.data;
                    let filtro = this.filtrosDisplay.find(x => x.ValorName == 'periodoevaluacionid');
                    if(filtro){
                        filtro.Opciones = this.SelPeriodoevaluacion;
                        filtro.Valor = this.SelPeriodoevaluacion[0].periodoevaluacionid;
                    }
                    return resolve(true);
                }
                else{
                    return resolve(false);
                }
            });
        });
    }

    SetDepartamentoFiltro() {
        return new Promise((resolve : any) =>{
            this.appService.Post("configuracionrh/departamento/buscar",{}).then(res =>{
                if (res.status == RespuestaEstatusEnum.Success){
                    this.SelDepartamento = res.data;
                    let filtro = this.filtrosDisplay.find(x => x.ValorName == 'departamentoid');
                    if (filtro){
                        filtro.Opciones = this.SelDepartamento;
                        filtro.Suscripcion.subscribe((v: number) =>{
                            this.SetPuestoFiltro(v).then((respuesta : any) =>{
                            });
                        });

                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                }
                else{
                    return resolve(false);
                }
            });
        });
    }

    SetPuestoFiltro(id:number){
        return new Promise ((resolve) =>{
            let filtro = this.filtrosDisplay.find(x => x.ValorName == 'puestoid');
            let filtroindex = this.filtrosDisplay.findIndex(x => x.ValorName == 'puestoid');
            if (filtro){
                filtro.Valor = null;
                if (!id){
                    this.SelPuesto = [];
                    filtro.Opciones = this.SelPuesto;
                    return resolve(true);
                }
                this.appService.Post("configuracionrh/puesto/buscar", {activo: 1, "departamentoid":id}).then(res =>{
                    if (res.status == RespuestaEstatusEnum.Success){
                        this.SelPuesto = res.data;
                        if (filtro){
                            if(this.filtrosComponent.filtrosSeleccionados.length > 0){
                                this.filtrosComponent.filtrosSeleccionados[filtroindex].Opciones = this.SelPuesto;
                            }else{
                                filtro.Opciones = this.SelPuesto;
                            }
                        }
                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                });
            }
            else{
                return resolve(false);
            }
        });
    }

    SetDatos(data:any){
        this.dataTable = data;
    }

    //Formulario para validar que accion se va arealizar y mandar la informacion a la nueva pantalla
    Formulario(accionid: number, entidad: any) {
        let accion: string = ""
        switch (accionid) {
            case 1:
                accion = "Colaboradores";
                break;
            case 2:
                accion = "Padres de familia";
                break;
            case 3:
                accion = "Estudiantes";
                break;
            case 4:
                accion = "Estudiantes preescolar y primaria";
                break;
            case 5:
                accion = "Talleres extracurriculares - Estudiantes";
                break;
            case 6:
                accion = "Talleres extracurriculares - Padres de familia";
                break;
        }
        this.cargarContenedorFormulario({accionid: accionid, accion: accion, entidad: entidad});
    }

    //Carga el contenedor con la informacion de la nueva pantalla
    cargarContenedorFormulario(data: {accionid: number, accion: string, entidad: any}) {
        this.consulta = true;
        this.preguntasenviadasdetalle.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(ReporteEvaluacionPendientePreguntaEnviadaDetalleComponent);
        var ref: ComponentRef<any> = this.preguntasenviadasdetalle.createComponent(factory);
        ref.instance.entidad = data.entidad;
        ref.instance.accion = {accionid: data.accionid, accion: data.accion};
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
        });
    }
}
